import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.string.includes.js";
import draggable from "vuedraggable";
import emptySort from "@/resource/images/empty-sort.png";
import { mapState } from "vuex";

// import {throttle} from '@/utils/util'
import { throttle, debounce } from "throttle-debounce";
import FormPage from '@/pages/design/components/FormPage';
export default {
  i18n: require('@/pages/design/design_i18n'),
  components: {
    FormPage: FormPage,
    draggable: draggable
  },
  data: function data() {
    return {
      loading: false,
      closeTip: null,
      // 拖拽组件参数
      dragOptions: {
        animation: 200,
        // 动画时间
        group: "description",
        disabled: false,
        ghostClass: "sortable-ghost",
        dragClass: "sortable-drag",
        filter: ".ignore-elements"
      },
      inDrag: false,
      // 是否正在拖拽
      inHover: 0,
      // 鼠标 hover 的 <li> 的 component_id
      images: {
        emptySort: emptySort
      },
      isExpand: true // 展开收起 true=展开 false=收起
      // component: null, // 选中的组件
    };
  },
  // created(){
  //   this.component = this.$store.state.design.selected_vdc;
  // },
  // watch: {
  //   selected_vdc_id () {
  //           this.component = this.$store.state.design.selected_vdc;
  //       }
  // },

  computed: _objectSpread(_objectSpread({}, mapState({
    component: function component(state) {
      return state.design.selected_vdc;
    },
    platform: function platform(state) {
      return state.design.platform;
    },
    components: function components(state) {
      return state.design.components || [];
    },
    // show: (state) => !state.design.show_component_form,
    selected_id: function selected_id(state) {
      return state.design.selected_id;
    },
    show: function show(state) {
      return state.design.show_component_form;
    },
    selected_vdc_id: function selected_vdc_id(state) {
      return state.design.selected_vdc && state.design.selected_vdc.id;
    }
  })), {}, {
    componentType: function componentType() {
      return function (item) {
        // 中间部分的组件没有draggable属性
        if (typeof item.draggable === 'undefined') {
          var location = item.componentValue.location;

          // 包含了 1,2 return PC | 移动
          // 包含了 1 return PC
          // 包含了 2 return 移动
          if (location.includes(1) && location.includes(2)) {
            return "PC | ".concat(this.$t('com.mobile'));
          }
          if (location.includes(1)) {
            return 'PC';
          }
          if (location.includes(2)) {
            return this.$t('com.mobile');
          }
          return '';
        } else {
          // 说明是固定位置的组件
          return item.type;
        }
      };
    }
  }),
  mounted: function mounted() {},
  methods: {
    throttle: throttle,
    debounce: debounce,
    tipNoDraggable: function tipNoDraggable() {
      var _this = this;
      var t = this.throttle(3000, false, function () {
        _this.$message.error(_this.$t('com.noDragHere'));
      });
      return t();
    },
    handleExpand: function handleExpand() {
      this.isExpand = !this.isExpand;
      // if(this.isExpand) {
      //   this.$store.commit('design/setShowForm')
      // }else {
      //   this.$store.commit('design/setHideForm')
      // }
    },
    onMove: function onMove(e) {
      var _this2 = this;
      var draggable = e.relatedContext.element.draggable;
      if (typeof draggable === "undefined") {
        return true;
      }
      if (draggable === false) {
        if (this.closeTip) return false;
        this.closeTip = this.$message.error(this.$t('com.noDragHere')).then(function () {
          _this2.closeTip = null;
        });
        return false;
      }
      return true;
    },
    /**
     * 删除组件
     * @param {Number} index 数组索引
     */
    handle_component_delete: function handle_component_delete(index) {
      this.components.splice(index, 1);
    },
    /**
     * 展示排序弹层
     */
    handle_show_sortable: function handle_show_sortable() {
      this.$store.dispatch("design/form_close");
    },
    /**
     * 中间预览区域，定位到点击的组件
     * @param {Vdc} component 组件对象
     */
    handle_location_component: function handle_location_component(component, index) {
      this.$store.dispatch("design/component_locate_by_floor", {
        component: component,
        index: index
      });
    }
  }
};